<li class="cursor">
  <a
    class="link text-decoration-none d-flex align-items-center w-100 fs-6"
    [ngClass]="{ sublevel: depth !== 0 }"
    routerLink="/{{ item.patch }}"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: depth == 0 && item.endpoint }"
    (click)="expand.emit({ item: item, index: index, depth: depth })"
  >
    <div
      class="bg-body"
      [ngClass]="{
        'vertical-line': depth == 0,
        'horizontal-line': depth !== 0
      }"
    ></div>
    @if(item.icon) {
    <div class="icon-container">
      <i class="bi {{ item.icon }}"></i>
    </div>
    }

    <span class="link-text overflow-hidden">{{ item.title | transloco }}</span>
  </a>

  @if(item.sublist && item.sublist.length > 0) {
  <ul class="list-unstyled sub-container" [ngClass]="{ expanded: item.expanded }">
    @for(child of item.sublist; track $index) {
    <app-sub-sidebar
      [item]="child"
      [depthVal]="depth + 1"
      [index]="$index"
      [clinicUrl]="clinicUrl"
      (expandSublevel)="
        expandSublevel.emit({
          item: child,
          index: index,
          subindex: $index,
          depth: depth + 1
        })
      "
    ></app-sub-sidebar
    >}
  </ul>
  }
</li>
